/**
 * Veroni PDP microtext live-update — fix #1 (owner report, 2026-07-14).
 *
 * snippets/variant-main-picker.liquid server-renders a microtext line right
 * after each Gemstone/Gold Color fieldset's <legend> — e.g.
 * "Gemstone — Amethyst" / "Gold color — Yellow" — sourced from
 * product_option.selected_value. That's correct on load and correct again
 * after Horizon's AJAX variant-picker morph (which re-fetches and swaps in
 * a fresh copy of this same server-rendered markup for the new variant),
 * but it goes stale for the brief window BETWEEN a real click and that
 * morph finishing, because the DOM's `checked` radio moves instantly while
 * the microtext text node doesn't.
 *
 * This script closes that gap with a tiny, framework-free instant update:
 * on `change` of any variant radio, find that radio's fieldset, and if it
 * has a microtext element, replace the text after the em dash with the
 * FULL selected value (the radio's raw `value` attribute — e.g. "White
 * Gold", never the shortened "White" the server uses for Gold Color) so
 * the shopper sees an immediate, always-correct label regardless of what
 * text convention the server happens to use for that option. The prefix
 * before the em dash (whatever the server rendered — "Gemstone" /
 * "Gold color" / any future option's own label) is left untouched, so this
 * requires no per-option-type name mapping and works for every current and
 * future microtext-bearing option on every product.
 *
 * Once the AJAX morph completes, the server-rendered markup (short label
 * included) replaces this fieldset outright — that's expected and correct;
 * this script only covers the instant feedback in between, per spec.
 *
 * Delegated on `document` (not per-fieldset listeners) so it keeps working
 * across Horizon's AJAX morphs without any re-binding step.
 */
(function () {
  var MICROTEXT_SELECTOR = '.v-gem-swatch-microtext, .v-gold-color-microtext';
  var EM_DASH = ' — ';

  function updateMicrotext(fieldset) {
    if (!fieldset) return;
    var microtext = fieldset.querySelector(MICROTEXT_SELECTOR);
    if (!microtext) return;
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    var value = (checked.value || '').trim();
    if (!value) return;

    var current = microtext.textContent || '';
    var dashIndex = current.indexOf(EM_DASH);
    var prefix = dashIndex === -1 ? current : current.slice(0, dashIndex);
    var next = prefix + EM_DASH + value;

    // No loops, no unconditional writes: only touch the DOM when the text
    // actually needs to change.
    if (current !== next) {
      microtext.textContent = next;
    }
  }

  function handleChange(event) {
    var target = event.target;
    if (!target || target.tagName !== 'INPUT' || target.type !== 'radio') return;
    var fieldset = target.closest('fieldset.variant-option');
    updateMicrotext(fieldset);
  }

  // Delegate on document so this survives any AJAX-replaced variant-picker
  // subtree without needing to re-bind listeners.
  document.addEventListener('change', handleChange);

  // Safety net for the post-morph window: re-sync every fieldset's
  // microtext against its own (now server-correct) checked radio right
  // after Horizon's variant-picker swaps in new markup. Normally a no-op
  // (the server already rendered the right value) — guards against any
  // brief mismatch and needs no extra state.
  var variantPicker = document.querySelector('variant-picker');
  if (variantPicker && 'MutationObserver' in window) {
    var observer = new MutationObserver(function () {
      variantPicker.querySelectorAll('fieldset.variant-option').forEach(updateMicrotext);
    });
    observer.observe(variantPicker, { childList: true, subtree: true });
  }
})();
